import React, { Component } from "react";
import {
  findImportInfo,
  confirmFileUpload,
  getParseAndCheckState,
  closeImport,
  doImport
} from "../upload.api";
import {Modal,Steps,Button,message} from "antd";
import SingleFileUpload from "./singleFileUpload";
import DataConfirm from "./dataConfirm";
import UploadResult from "./uploadResult";
import TemplateDownload from "./templateDownload";
const { confirm } = Modal;
const { Step } = Steps;
interface iProps {
  url: string;
  templateSn: string;
  bizParam: any;
  visible: boolean;
  onFinish?: () => void;
  onCancel: () => void;
  width?: number;
}
export default class ExcelUpload extends Component<iProps> {
  state = {
    templateDownload: {
      description: "",
      templateFileURL: "",
      templateFileName: "",
    },
    importInfo: {
      importState: "",
      importToken: "",
      title: "",
      currentStep: 0,
    },
    singleFileUpload: {
      parseState: "",
      file: null,
      loading: false,
    },
    dataConfirm:{
      loading: false,
    },
    uploadResult: {
      loading: true,
    },
  };
  componentWillReceiveProps(newProps) {
    if (newProps.visible) {
      this.init();
    }
  }
  init = async () => {
    let { data } = await findImportInfo(
      {
        templateSn: this.props.templateSn,
        bizParam: this.props.bizParam,
      },
      this.url
    );
    let {
      description,
      importState,
      importToken,
      templateFileName,
      templateFileURL,
      title,
    } = data;
    let currentStep = {
      UNSTART: 0,
      PREVIEW: 2,
      IMPORTING: 3,
      FINISHED: 3,
    }[importState];
    this.setState({
      templateDownload: {
        description,
        templateFileURL,
        templateFileName,
      },
      importInfo: {
        currentStep,
        importState,
        importToken,
        title,
      },
    });
  };
  doImport = async () => {
    this.setState({dataConfirm: {...this.state.dataConfirm, loading: true}})
    try {
      let data = await doImport(this.importToken,this.url);
      this.setState({dataConfirm: {...this.state.dataConfirm, loading: false}})
      if (data.data === "ok") {
        this.gotoNextStep();
      } else {
        message.warn(data["msg"]);
      }
    }
    catch {
      this.setState({dataConfirm: {...this.state.dataConfirm, loading: false}})
    }
  };
  getParseAndCheckState = async () => {
    let data = await getParseAndCheckState(this.importToken, this.url);
    this.setSingleFileUpload("parseState", data.data);
  };
  pollDataMessage = () => {
    window.setTimeout(async () => {
      if (this.state.singleFileUpload.parseState !== "FINISHED") {
        await this.getParseAndCheckState();
        this.pollDataMessage();
      } else {
        this.setSingleFileUpload("file", null);
        this.gotoNextStep();
      }
    }, 1000);
  };
  beforeDataCheck = async () => {
    if (!this.state.singleFileUpload.file) {
      message.warn("请上传文件！");
      return;
    }
    this.setSingleFileUpload("loading", true);
    let data = await confirmFileUpload(
      {
        importToken: this.importToken,
        excelFile: this.excelFile,
      },
      this.url
    );
    if (data.data === "ok") {
      this.pollDataMessage();
    } else {
      message.warn(data["msg"]);
    }
  };
  uploadFile = ([file]) => {
    this.setSingleFileUpload("file", file);
  };
  get url() {
    return this.props.url;
  }
  get importToken() {
    return this.state.importInfo.importToken;
  }
  get excelFile() {
    return this.state.singleFileUpload.file;
  }
  setSingleFileUpload = (key, value) => {
    this.setState({
      singleFileUpload: {
        ...this.state.singleFileUpload,
        [key]: value,
      },
    });
  };
  setCurrentStep = (step) => {
    this.setState({
      importInfo: {
        ...this.state.importInfo,
        currentStep: this.state.importInfo.currentStep + step,
      },
    });
  };
  gotoNextStep = () => {
    this.setCurrentStep(1);
  };
  gotoPreviousStep = () => {
    this.setCurrentStep(-1);
  };
  onReady = () => {
    this.setSingleFileUpload("loading", false);
  };
  onFinish = () => {
    this.setState({
      uploadResult: {
        loading: false,
      },
    });
  };
  finishImport = async () => {
    await closeImport(this.importToken, this.url);
    this.props.onFinish();
    this.clearState();
  };
  clearState = () => {
    this.setState({
      templateDownload: {
        description: "",
        templateFileURL: "",
        templateFileName: "",
      },
      importInfo: {
        importState: "",
        importToken: "",
        title: "",
        currentStep: 0,
      },
      singleFileUpload: {
        parseState: "",
        file: null,
        loading: false,
      },
      uploadResult: {
        loading: true,
      },
    });
  };
  get modalFooter() {
    let { dataConfirm,singleFileUpload,uploadResult } = this.state;
    switch (this.state.importInfo.currentStep) {
      case 0:
        return (
          <Button type="primary" onClick={this.gotoNextStep}>
            下一步
          </Button>
        );

      case 1:
        return (
          <>
            <Button
              disabled={singleFileUpload.loading}
              onClick={() => {
                this.setSingleFileUpload("file", null);
                this.gotoPreviousStep();
              }}
            >
              上一步
            </Button>
            <Button
              type="primary"
              loading={singleFileUpload.loading}
              onClick={this.beforeDataCheck}
            >
              {singleFileUpload.loading ? "正在校验文件" : "下一步"}
            </Button>
          </>
        );
      case 2:
        return (
          <>
            <Button onClick={this.gotoPreviousStep}>重新上传</Button>
            <Button loading={dataConfirm.loading} type="primary" onClick={this.doImport}>
              确定导入
            </Button>
          </>
        );
      case 3:
        return (
          <Button
            type="primary"
            loading={uploadResult.loading}
            onClick={this.finishImport}
          >
            {uploadResult.loading ? "正在导入" : "完成"}
          </Button>
        );

      default:
        return null;
    }
  }
  confirm = () => {
    confirm({
      title: "您确定要结束这次导入任务?",
      okText: "确定",
      cancelText: "取消",
      onOk: () => {
        return new Promise<void>((resolve, reject) => {
          closeImport(this.importToken, this.url)
            .then(() => {
              resolve();
              this.clearState();
              this.props.onCancel();
            })
            .catch(() => reject());
        }).catch(() => {
          this.clearState();
          this.props.onCancel();
        });
      },
    });
  };
  render() {
    let { visible, width = 952 } = this.props;
    let {
      description = "",
      templateFileURL = "",
      templateFileName = "",
    } = this.state.templateDownload;
    let { title = "", currentStep = 0 } = this.state.importInfo;
    return (
      <Modal
        keyboard={false}
        maskClosable={false}
        visible={visible}
        title={title}
        width={width}
        onCancel={this.confirm}
        footer={this.modalFooter}
      >
        <div className="excel-upload">
          <Steps current={currentStep}>
            <Step title="模板下载" />
            <Step title="数据上传" />
            <Step title="数据确认" />
            <Step title="导入数据" />
          </Steps>

          {currentStep === 0 && (
            <TemplateDownload
              templateFileURL={templateFileURL}
              templateFileName={templateFileName}
              description={description}
            ></TemplateDownload>
          )}
          {currentStep === 1 && (
            <SingleFileUpload
              uploadSignURL={this.url}
              onChange={this.uploadFile}
            ></SingleFileUpload>
          )}
          {currentStep === 2 && (
            <DataConfirm
              url={this.url}
              onReady={this.onReady}
              importToken={this.importToken}
            ></DataConfirm>
          )}
          {currentStep === 3 && (
            <UploadResult
              url={this.url}
              importToken={this.importToken}
              onFinish={this.onFinish}
            ></UploadResult>
          )}
        </div>
      </Modal>
    );
  }
}
